import { CoaProvidedBanner } from '../components/CoaProvidedBanner';
import { useCoaProvidedBannerService } from '../services/useCoaProvidedBannerService';

export const CoaProvidedBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { coa_provided_banner_image_url } = useCoaProvidedBannerService();

  if (!coa_provided_banner_image_url) {
    return null;
  }

  return <CoaProvidedBanner coa_provided_banner_image_url={coa_provided_banner_image_url} />;
};
